import { render } from "./ConfirmAccount.vue?vue&type=template&id=cafa130c&scoped=true"
import script from "./ConfirmAccount.vue?vue&type=script&lang=js"
export * from "./ConfirmAccount.vue?vue&type=script&lang=js"

import "./ConfirmAccount.vue?vue&type=style&index=0&id=cafa130c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cafa130c"]])

export default __exports__